import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';  // import Bootstrap CSS globally
import 'bootstrap-icons/font/bootstrap-icons.css'; // optional, if using Bootstrap icons
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
